<div class="min-h-screen flex flex-column align-content-center justify-content-center">
  <router-outlet ></router-outlet>
</div>
